import React, { useRef } from "react";
import { useSelectedZone } from "../../hooks/useSelection";
import { useHoldAction } from "../../hooks/useHoldAction";
import { usePhotoZooming } from "../slideshow-preview/hooks/use-photo-zooming";
import { FloatingBar } from "../floating-bar";

import { Icon } from "../icon";

const zoomAccel = 0.001;

export function ZoneTransformMenu() {
	const selectedZone = useSelectedZone();
	const photoLookZone = eXpress.core.isPhotoLookZone(selectedZone) ? selectedZone : undefined;
	const [{ canZoomIn, canZoomOut }, photoZooming] = usePhotoZooming();

	const zoomRef = useRef<
		| {
				zoomTime: number;
				zoomSpeed: number;
		  }
		| undefined
	>(undefined);

	function zoomOnHold(index: number, dt: number, isZoomOut: boolean) {
		if (!zoomRef.current) return;

		if (index === 0) {
			// Single Click
			photoZooming.update(1.05, isZoomOut);
		} else if (index >= 5) {
			if (index === 5) {
				// Reset zoom time after initial delay
				zoomRef.current.zoomTime = 0.05;
			}
			// Long press: Start zooming in slowly, then increase speed.
			zoomRef.current.zoomTime += dt * zoomRef.current.zoomSpeed;
			zoomRef.current.zoomSpeed = eXpress.math.clamp(
				zoomRef.current.zoomSpeed + dt * zoomAccel,
				0,
				5,
			);
			const zoomFactor = Math.exp(zoomRef.current.zoomTime);
			photoZooming.update(zoomFactor, isZoomOut);
		}
	}

	const zoomInHold = useHoldAction({
		onStart: () => {
			if (!photoLookZone) return;
			zoomRef.current = {
				zoomTime: 0,
				zoomSpeed: 0.01,
			};
			photoZooming.start({ selectedZone: photoLookZone });
		},
		onAction: (index, _, dt) => {
			zoomOnHold(index, dt, false);
		},
		onEnd: () => {
			zoomRef.current = undefined;
			photoZooming.end();
		},
	});

	const zoomOutHold = useHoldAction({
		onStart: () => {
			if (!photoLookZone) return;
			zoomRef.current = {
				zoomTime: 0,
				zoomSpeed: 0.01,
			};
			photoZooming.start({ selectedZone: photoLookZone });
		},
		onAction: (index, _, dt) => {
			zoomOnHold(index, dt, true);
		},
		onEnd: () => {
			zoomRef.current = undefined;
			photoZooming.end();
		},
	});

	return (
		<FloatingBar.Root>
			<FloatingBar.Button
				onPointerDown={zoomOutHold.startHold}
				onPointerUp={zoomOutHold.stopHold}
				onPointerLeave={zoomOutHold.stopHold}
				onPointerCancel={zoomOutHold.stopHold}
				onContextMenu={(e) => {
					e.preventDefault();
				}}
				disabled={!canZoomOut}
			>
				<Icon iconName="minus" />
			</FloatingBar.Button>
			<FloatingBar.Button
				onPointerDown={zoomInHold.startHold}
				onPointerUp={zoomInHold.stopHold}
				onPointerLeave={zoomInHold.stopHold}
				onPointerCancel={zoomInHold.stopHold}
				onContextMenu={(e) => {
					e.preventDefault();
				}}
				disabled={!canZoomIn}
			>
				<Icon iconName="plus" />
			</FloatingBar.Button>
		</FloatingBar.Root>
	);
}
